import { useEffect, useState } from 'react'
import { useDndMonitor, useDraggable } from '@dnd-kit/core'

import { useTheme } from '@mui/material/styles'

import { WIDGET_HEIGHT, WIDGET_WIDTH } from './VoiceWidget.utils'

function clampPosition({ x, y }) {
  const maxX = Math.max(0, window.innerWidth - WIDGET_WIDTH)
  const maxY = Math.max(0, window.innerHeight - WIDGET_HEIGHT)
  return {
    x: Math.min(Math.max(x, 0), maxX),
    y: Math.min(Math.max(y, 0), maxY),
  }
}

export function useDraggableWidget() {
  const theme = useTheme()

  const [position, setPosition] = useState(() =>
    clampPosition({
      x: window.innerWidth - WIDGET_WIDTH - 8,
      y: theme.mixins.toolbar.height + 8,
    })
  )

  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: 'phone-call-widget',
    activationConstraint: {
      delay: 250,
      distance: 3,
    },
  })

  useDndMonitor({
    onDragEnd(event) {
      const { delta } = event
      setPosition((prev) => clampPosition({ x: prev.x + delta.x, y: prev.y + delta.y }))
    },
  })

  useEffect(() => {
    const onResize = () => setPosition((prev) => clampPosition(prev))
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  const style = transform ? { transform: `translate3d(${transform.x}px, ${transform.y}px, 0)` } : undefined

  return { position, setNodeRef, listeners, attributes, style }
}
